import { procurementAPI } from "../../axios";

export const actions = {

    //Pr
    GetPrByCycle(context, data){
        return procurementAPI.get(`Pr/My/${data.cycle}/${data.deliveryUnitId}/${data.departmentId}`);
    },
    GetSinglePr(context, data){
        return procurementAPI.get(`Pr/${data}`);
    },
    GetPRCarts(context, data){
        return procurementAPI.get(`Pr/Draft/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetNewPRCarts(context, data){
        return procurementAPI.get(`Pr/Draft/${data.deliveryUnitId}/${data.departmentId}/${data.cycle}`);
    },
    GetPostedPr(context, data){
        return procurementAPI.get(`Pr/posted/${data.cycle}/${data.campusId}`);
    },
    GetApprovedPr(context, data){
        return procurementAPI.get(`Pr/approved/${data.cycle}/${data.campusId}`);
    },
    GetSubmittedPr(context, data){
        return procurementAPI.get(`Pr/submitted/${data.cycle}/${data.campusId}`);
    },
    GetCancelledPr(context, data){
        return procurementAPI.get(`Pr/Cancelled/${data.cycle}/${data.campusId}`);
    },
    GetReturnedPr(context, data){
        return procurementAPI.get(`Pr/Returned/${data.cycle}/${data.deliveryUnitId}`);
    },
    CancelPr(context, data){
        return procurementAPI.put(`Pr/Cancel/${data.id}`, data);
    },
    UpdatePr(context, data){
        return procurementAPI.put(`Pr/${data.id}`, data);
    },
    UpdatePrDetails(context, data){
        return procurementAPI.put(`Pr/Update/Details/${data.id}`, data);
    },
    UpdatePrDate(context, data){
        return procurementAPI.put(`Pr/Update/PostedDate/${data.id}`, data);
    },
    UpdatePrDescription(context, data){
        return procurementAPI.put(`Pr/Update/Description/${data.id}`, data);
    },
    DeletePr(context, data){
        return procurementAPI.delete(`Pr/${data}`);
    },
    CreatePr(context, data){
        return procurementAPI.post(`Pr/CreatePr`, data);
    },
    CreatePrMigration(context, data){
        return procurementAPI.post(`Pr/Create/MigrationPr`, data);
    },
    SubmitPr(context, data){
        return procurementAPI.put(`Pr/Submit/${data}`);
    },
    PostPr(context, data){
        return procurementAPI.put(`Pr/post/${data.id}`, data);
    },
    ApprovePr(context, data){
        return procurementAPI.put(`Pr/approve/${data.id}/${data.bacSettingId}/${data.modeOfProcurementId}`);
    },
    MoveToCampus(context, data){
        return procurementAPI.put(`Pr/Move/${data.id}/${data.campusId}`);
    },
    ReturnPr(context, data){
        return procurementAPI.put(`Pr/return/${data.id}?remarks=${data.remarks}`);
    },
    GetMyFSperCycle(context, data){
        return procurementAPI.get(`Pr/FundSources/${data}`);
    },
    GetMigrationPerCycle(context, data){
        return procurementAPI.get(`Pr/Migration/${data}`);
    },
    GetMyMigration(context, data){
        return procurementAPI.get(`Pr/Migration/My/${data}`);
    },
    ReturnToPending(context, data){
        return procurementAPI.put(`Pr/Return/Posted/${data}`);
    },
    TransferCycle(context, data){
        return procurementAPI.put(`Pr/Update/Cycle/${data.id}/${data.cycle}`);
    },
    UpdatePRNo(context, data){
        return procurementAPI.put(`Pr/Update/PrNumber/${data.id}`, data);
    },
    GetPublicBidding(context, data){
        return procurementAPI.get(`Pr/PublicBidding/${data.cycle}/${data.campusId}`);
    },
    
}